// extracted by css-extract-rspack-plugin
var _1 = "ElementIcon-m_d1Badge-GkomWZL7";
var _2 = "ElementIcon-m_element-e0VY8WPa";
export { _1 as "d1Badge", _2 as "element" }
